var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('v-avatar',{attrs:{"size":_vm.size || 25,"left":""}},[_c('v-img',{attrs:{"src":_vm.image}})],1):_c('v-avatar',{attrs:{"color":_vm.color || _vm.roleColor(_vm.role),"size":_vm.size || 25,"left":""}},[_c('span',{staticClass:"white--text",class:_vm.contentClass},[_vm._v(_vm._s(_vm.initialsFromFullName(_vm.name)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }